  <!-- タイトル -->
  <div class="title-area">
    <div class="title-left">
      <h2 mat-subheader class="title">組織情報</h2>
    </div>
  </div>
  @if (showSpinner) {
    <div class="spinner center">
      <mat-spinner></mat-spinner>
    </div>
  } @else {
  <!-- カード -->
  <div class="card">
    <form [formGroup]="form">
        <div class="form-grid">

            <div class="form-row">
              <label>組織名</label>
              <mat-form-field appearance="outline" class="readonly-input">
                <input matInput formControlName="orgName" readonly (keydown.enter)="$event.preventDefault()">
              </mat-form-field>
            </div>

            <div class="form-row">
              <label>業種</label>
              <mat-form-field appearance="outline">
                <mat-select formControlName="industryLarge" panelClass="org-about-select-panel" #industrySelect (keydown)="onSelectChange(industrySelect )" (keydown.enter)="$event.preventDefault()">
                  <mat-option *ngFor="let item of industryLarges" [value]="item.value">
                    {{ item.label }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>

            <div class="form-row">
              <label>従業員規模</label>
              <mat-form-field appearance="outline">
                <mat-select formControlName="employeeSize" panelClass="org-about-select-panel" #employeeSelect (keydown)="onSelectChange(employeeSelect)" (keydown.enter)="$event.preventDefault()">
                  <mat-option *ngFor="let item of employeeSizes" [value]="item.value">
                    {{ item.label }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>

            <div class="form-row">
              <label>拠点分散</label>
              <mat-form-field appearance="outline">
                <mat-select formControlName="location" panelClass="org-about-select-panel" #locationSelect (keydown)="onSelectChange(locationSelect)" (keydown.enter)="$event.preventDefault()">
                  <mat-option *ngFor="let item of locations" [value]="item.value">
                    {{ item.label }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>

            <div class="form-row">
              <label>職種構成</label>
              <mat-form-field appearance="outline">
                <mat-select formControlName="jobType" panelClass="org-about-select-panel" #jobTypeSelect (keydown)="onSelectChange(jobTypeSelect)" (keydown.enter)="$event.preventDefault()">
                  <mat-option *ngFor="let item of jobTypes" [value]="item.value">
                    {{ item.label }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>

            <div class="form-row">
              <label>雇用形態</label>
              <mat-form-field appearance="outline">
                <mat-select formControlName="employmentType" panelClass="org-about-select-panel" #employmentSelect (keydown)="onSelectChange(employmentSelect)" (keydown.enter)="$event.preventDefault()">
                  <mat-option *ngFor="let item of employmentTypes" [value]="item.value">
                    {{ item.label }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>

        </div>

      <!-- 保存ボタン -->
      <div class="button-area">
        <div class="signup-wrapper">
          <button mat-raised-button color="primary" (click)="onSave()" [disabled]="isSaving || form.invalid" class="yes-btn">
            保存
          </button>
          @if (isSaving) {
            <mat-spinner diameter="28" class="spinner2"></mat-spinner>
          }
        </div>
      </div>

    </form>
  </div>
  <div class="card-footer">
    最終更新 {{ formatDate(company.updated_at) }}
    &nbsp;&nbsp;
    {{ company.officialposition_name }}
    {{ company.last_name }} {{ company.firstName }}
  </div>

}